import {getOpenInNewIcon} from "../../js/util/IconUtils.js";

export default class HeaderMenuHtml {
    /** @type {HTMLElement} */
    #parent;
    #hideMenuFunction;

    constructor() {
        this.#hideMenuFunction = this.#hide.bind(this);
    }

    /** @param {HTMLElement} parent */
    init(parent) {
        this.#parent = parent;
        this.#parent.insertAdjacentHTML('beforeend', this.#template());
        this.#getMenuIcon().addEventListener('click', this.#toggleMenuVisibility.bind(this));
    }

    #show() {
        window.addEventListener('click', this.#hideMenuFunction);
        this.#getMenuElement().showModal();
        this.#getMenuElement().focus();
        this.#addListeners();
    }

    /** @param {Event} event */
    #hide(event) {
        event.stopPropagation()
        this.#getMenuElement().close();
        this.#getMenuElement().removeEventListener('click', this.#hideMenuFunction);
    }

    /** @returns {boolean} */
    #isVisible() {
        return this.#getMenuElement().hasAttribute('open');
    }

    /** @returns {HTMLDialogElement} */
    #getMenuElement() {
        return this.#parent.querySelector('.header-menu');
    }

    /** @returns {HTMLElement} */
    #getMenuIcon() {
        return this.#parent.querySelector('[data-action="open"]');
    }

    #addListeners() {
        // This listener prevents the menu from closing when clicking inside the dialog box
        this.#parent.querySelector('.header-menu__menu-wrapper').addEventListener('click', (event) => {
            event.stopPropagation();
        })
    }

    /** @param {Event} event */
    #toggleMenuVisibility(event){
        event.stopPropagation();
        if (this.#isVisible())
            this.#hide(event);
        else
            this.#show();
    }

    /** @returns {string} */
    #template() {
        return `
            <span data-action="open" class="header-menu__icon">Apps 
                <span class="material-icons header-menu__dropdown-icon">arrow_drop_down</span>
            </span>
            <dialog class="header-menu">
                <menu class="header-menu__menu-wrapper">
                    <ul class="header-menu__list">
                        <li class="header-menu__list-item">
                            <a href="https://elsci.io/molbrett/index.html" class="header-menu__clickable-item" target="_blank">
                                <div class="header-menu__item-title">Molbrett</div>
                                <p class="header-menu__item-description">Draw molecules and synthetic routes</p>
                            </a>
                            <a href="https://molbrett.elsci.io/" class="header-menu__app-link" target="_blank"> 
                                <span class="header-menu__link">Cloud version</span>${getOpenInNewIcon('header-menu__open-in-new-icon')}
                            </a>
                        </li>
                        <li class="header-menu__list-item">
                            <a href="https://elsci.io/peaksel/index.html" class="header-menu__clickable-item" target="_blank">
                                <div class="header-menu__item-title">Peaksel</div>
                                <p class="header-menu__item-description">HPLC processing and storage</p>
                            </a>
                            <a href="https://peaksel.elsci.io/" class="header-menu__app-link" target="_blank"> 
                                <span class="header-menu__link">Cloud version</span>${getOpenInNewIcon('header-menu__open-in-new-icon')}
                            </a>
                        </li>
                        <li class="header-menu__list-item">
                            <a href="https://elsci.io/crystaline/index.html" class="header-menu__clickable-item" target="_blank">
                                <div class="header-menu__item-title">Crystaline</div>
                                <p class="header-menu__item-description">Design and capture X-ray crystallography experiments</p>
                            </a>
                        </li>
<!--                        <li class="header-menu__list-item">-->
<!--                            <a href="" class="header-menu__clickable-item" target="_blank">-->
<!--                                <div class="header-menu__item-title">Molbrett</div>-->
<!--                                <div class="header-menu__item-description">Sketch molecular ideas, synthesis routes</div>-->
<!--                                <a href="" target="_blank" class="header-menu__item-link">-->
<!--                                    <span class="header-menu__link" >Open cloud version</span>-->
<!--                                    ${getOpenInNewIcon('header-menu__open-in-new-icon')}-->
<!--                                </a>-->
<!--                            </a>-->
<!--                        </li>-->
                    </ul>
                </menu>
            </dialog>`
    }
}
